export default "__VITE_ASSET__dvWUnVP0__"